import { useState } from "react";
import GeolocationTrackingService from "../services/api/geolocation-tracking";

const useGeolocation= () => {

    const [isLoadingGetVerificationCount, setIsLoadingGetVerificationCount] = useState(false)
    const [verificationCountData, setVerificationCountData] = useState([])
    const [verificationCountErr, setVerificationCountErr] = useState(null)

    const [isLoadingGetVerificationLatLng, setIsLoadingGetVerificationLatLng] = useState(false)
    const [verificationLatLngData, setVerificationLatLngData] = useState([])
    const [verificationLatLngErr, setVerificationLatLngErr] = useState(null)

    const [isLoadingGetScanningActivity, setIsLoadingGetScanningActivity] = useState(false)
    const [scanningActivityData, setScanningActivityData] = useState(null)
    const [scanningActivityErr, setScanningActivityErr] = useState(null)

    const getVerificationCount = (filters) => {
        let geolocationAPI = null;
        let country = filters.country
        let startDate = filters.startDate
        let endDate = filters.endDate
        let region = filters.region
        let product_code = filters.product_code

        if (country && startDate && endDate) {
            geolocationAPI = GeolocationTrackingService.getVerificationCountPerRegion(startDate, endDate, country, product_code)
        } else if(country && startDate && endDate && region){
            geolocationAPI = GeolocationTrackingService.getVerificationCountPerProvince(startDate, endDate, country, region, product_code)
        }

        if (geolocationAPI != null) {
            setIsLoadingGetVerificationCount(true)
            geolocationAPI.then((res) => {
                console.log("getVerificationCount xxx", res.data);
                setIsLoadingGetVerificationCount(false)
                if (res.data.success) {
                    setVerificationCountData(res.data.data)
                } else {
                    setVerificationCountErr(res.data.error)
                }
            }).catch((e) => {
                setIsLoadingGetVerificationCount(false)
                setVerificationCountErr(e)
            })
        }
    }

    const getVerificationLatLng = (filters) => {
        let geolocationAPI = null;
        let country = filters.country
        let startDate = filters.startDate
        let endDate = filters.endDate
        let region = filters.region
        let province = filters.province
        let product_code = filters.product_code

        if (country && startDate && endDate && region) {
            geolocationAPI = GeolocationTrackingService.getVerificationLatLngPerRegion(startDate, endDate, country, region, product_code)
        } else if (country && startDate && endDate && region && province) {
            geolocationAPI = GeolocationTrackingService.getVerificationLatLngPerProvince(startDate, endDate, country, region, province, product_code)
        }

        if (geolocationAPI != null) {
            setIsLoadingGetVerificationLatLng(true)
            geolocationAPI.then((res) => {
                console.log("getVerificationLatLng xxx", res.data);
                
                setIsLoadingGetVerificationLatLng(false)
                if (res.data.success) {
                    setVerificationLatLngData(res.data.data)
                } else {
                    setVerificationLatLngErr(res.data.error)
                }
            }).catch((e) => {
                setIsLoadingGetVerificationLatLng(false)
                setVerificationLatLngErr(e)
            })
        }
    }

    const getScanningActivity = (filters) => {
        let country = filters.country
        let startDate = filters.startDate
        let endDate = filters.endDate
        let region = filters.region
        let province = filters.province
        let product_code = filters.product_code
        let page = 1
        let limit = 5

        setIsLoadingGetScanningActivity(true)
        GeolocationTrackingService.getScanningActivity(startDate, endDate, country, region, province, product_code, page, limit).then((res) => {
            if (res.data.success) {
                setScanningActivityData(res.data.data);
                setIsLoadingGetScanningActivity(false);

            } else {
                setScanningActivityErr(res.data.error)
                setIsLoadingGetScanningActivity(false);
            }
        }).catch((e) => {
            setIsLoadingGetScanningActivity(false)
            setScanningActivityErr(e)
        })
    }

    return {
        getVerificationCount, isLoadingGetVerificationCount, verificationCountData, verificationCountErr,
        getVerificationLatLng, isLoadingGetVerificationLatLng, verificationLatLngData, verificationLatLngErr,
        getScanningActivity, isLoadingGetScanningActivity, scanningActivityData, scanningActivityErr,
    }
}

export default useGeolocation